import React from 'react';
export default function Admin(props) {
  var className = props.className,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    style: style,
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "logo admin@1x"), /*#__PURE__*/React.createElement("g", {
    id: "logo-admin",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.448276,0 C437.955101,0 512,74.0448993 512,171.551724 L512,340.448276 C512,437.955101 437.955101,512 340.448276,512 L171.551724,512 C74.0448993,512 0,437.955101 0,340.448276 L0,171.551724 C0,74.0448993 74.0448993,0 171.551724,0 L340.448276,0 Z",
    id: "background",
    fill: "#1DAB8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,215 L137.8,299 L128.44,299 L118.36,276.56 L71.56,276.56 L61.48,299 L52.24,299 L90.64,215 L99.4,215 Z M94.96,224.24 L74.8,269.36 L115.12,269.36 L94.96,224.24 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.92,215 L181.70083,215.004619 C190.260277,215.106246 197.84,216.884706 204.44,220.34 C211.24,223.9 216.52,228.86 220.28,235.22 C224.04,241.58 225.92,248.84 225.92,257 C225.92,265.16 224.04,272.42 220.28,278.78 C216.52,285.14 211.24,290.1 204.44,293.66 C197.64,297.22 189.8,299 180.92,299 L180.92,299 L146.72,299 L146.72,215 L180.92,215 Z M180.44,222.68 L155.6,222.68 L155.6,291.32 L180.44,291.32 C187.8,291.32 194.24,289.86 199.76,286.94 C205.28,284.02 209.56,279.98 212.6,274.82 C215.64,269.66 217.16,263.72 217.16,257 C217.16,250.28 215.64,244.34 212.6,239.18 C209.56,234.02 205.28,229.98 199.76,227.06 C194.24,224.14 187.8,222.68 180.44,222.68 L180.44,222.68 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "249.36 299 249.36 232.16 282.36 288.32 286.56 288.32 319.56 231.8 319.56 299 328.08 299 328.08 215 320.76 215 284.64 277.28 248.16 215 240.84 215 240.84 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "359.32 299 359.32 215 350.44 215 350.44 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "390.56 299 390.56 230.84 444.56 299 451.88 299 451.88 215 443.12 215 443.12 283.16 389 215 381.68 215 381.68 299"
  })));
}
Admin.defaultProps = {
  style: undefined,
  className: undefined
};